const createSagaSymbol = (name) => `@MGX_SAGA/${name}`;

export const CHANNEL_END = createSagaSymbol('END');

export const SIGNAL = createSagaSymbol('PROC-IO');

export const MATCH = createSagaSymbol('MATCH');
export const CANCEL = createSagaSymbol('CANCEL');

export const SAGA_ACTION = createSagaSymbol('SAGA_ACTION');
export const SAGA_LOCATION = createSagaSymbol('SAGA_LOCATION');

export const TASK = createSagaSymbol('TASK');
export const TASK_CANCEL = createSagaSymbol('TASK_CANCEL');
export const TERMINATE = createSagaSymbol('TERMINATE');
export const SELF_CANCELLATION = createSagaSymbol('SELF_CANCELLATION');
